import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-abc07c70"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  role: "tabpanel",
  class: "tab-pane active col-sm-12",
  id: "members"
}
const _hoisted_2 = { class: "col-md-8 no-left-padding" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Members", -1))
const _hoisted_4 = { class: "table" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "col-md-10"
    }, "Filter by"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "col-md-2"
    }, "members")
  ])
], -1))
const _hoisted_6 = { "data-test": "all-members-length" }
const _hoisted_7 = { "data-test": "guest-members-length" }
const _hoisted_8 = { "data-test": "has-solo-length" }
const _hoisted_9 = { "data-test": "viewpoints-length" }
const _hoisted_10 = { "data-test": "setup-team-length" }
const _hoisted_11 = { "data-test": "teqs-length" }
const _hoisted_12 = { "data-test": "develop-length" }
const _hoisted_13 = { "data-test": "pathways-length" }

import { computed, ref } from "vue";
import OrganisationDetails from "./organisation-details.vue";
import { OrganisationAndMembersApiModel, OrganisationMemberApiModel } from "../../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'members-tab',
  props: {
    model: {}
  },
  emits: ["revalidate-org-data"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const appliedFilter = ref<string | null>(null);

const toggleFilter = (filter: string): void => {
  appliedFilter.value = appliedFilter.value === filter ? null : filter;
};

const revalidateOrgData = (): void => {
  emit("revalidate-org-data");
};

const guestMembers = computed((): OrganisationMemberApiModel[] => {
  return props.model?.members.filter((x) => x.subscriptionLevel === "Guest") ?? [];
});

const peopleWithSoloReports = computed((): OrganisationMemberApiModel[] => {
  return props.model?.members.filter((x) => x.solo) ?? [];
});

const peopleWithTwoViewpoints = computed((): OrganisationMemberApiModel[] => {
  return props.model?.members.filter((x) => x.viewpoints?.length > 1) ?? [];
});

const peopleWithDevelopPlans = computed((): OrganisationMemberApiModel[] => {
  return (
    props.model?.members.filter(
      (x) =>
        (x.development && x.development.currentStrengthProgress?.strengthItemId) ||
        x.development.otherProgress?.some((progress) => progress),
    ) ?? []
  );
});

const peopleSetUpATeam = computed((): OrganisationMemberApiModel[] => {
  return props.model?.members.filter((x) => x.hasSetUpTeam) ?? [];
});

const peopleWithTEQs = computed((): OrganisationMemberApiModel[] => {
  return props.model?.members.filter((x) => x.teqsCompleted.length > 0) ?? [];
});

const peopleWithPathways = computed((): OrganisationMemberApiModel[] => {
  return props.model?.members.filter((x) => {
    return (
      (x.pathways.currentPathwaysInProgress?.length > 0 || x.pathways.otherProgress?.length > 0) ??
      []
    );
  });
});

const filteredMembers = computed((): OrganisationMemberApiModel[] => {
  if (!appliedFilter.value || appliedFilter.value === "all") return props.model?.members ?? [];
  if (appliedFilter.value === "guests") return guestMembers.value;
  if (appliedFilter.value === "solo") return peopleWithSoloReports.value;
  if (appliedFilter.value === "viewpoints") return peopleWithTwoViewpoints.value;
  if (appliedFilter.value === "setup_team") return peopleSetUpATeam.value;
  if (appliedFilter.value === "teq") return peopleWithTEQs.value;
  if (appliedFilter.value === "plans") return peopleWithDevelopPlans.value;
  if (appliedFilter.value === "pathways") return peopleWithPathways.value;
  return [];
});

const sortedMembers = computed((): OrganisationMemberApiModel[] => {
  return [...filteredMembers.value].sort((a, b) => {
    // Admins come before non-admins
    if (a.role === "Admin" && b.role !== "Admin") {
      return -1;
    }
    return 1;
  });
});

return (_ctx: any,_cache: any) => {
  return (_ctx.model)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("table", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleFilter('all'))),
                    "data-test": "all-members-filter"
                  }, " All Members")
                ]),
                _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.model.members.length), 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleFilter('guests'))),
                    "data-test": "guest-members-filter"
                  }, "Guest Members")
                ]),
                _createElementVNode("td", _hoisted_7, _toDisplayString(guestMembers.value.length), 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleFilter('solo'))),
                    "data-test": "has-solo-filter"
                  }, " Members with completed Solos")
                ]),
                _createElementVNode("td", _hoisted_8, _toDisplayString(peopleWithSoloReports.value.length), 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleFilter('viewpoints'))),
                    "data-test": "viewpoints-filter"
                  }, " Members with 2+ Viewpoints")
                ]),
                _createElementVNode("td", _hoisted_9, _toDisplayString(peopleWithTwoViewpoints.value.length), 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleFilter('setup_team'))),
                    "data-test": "setup-team-filter"
                  }, " Members who have set up a Team")
                ]),
                _createElementVNode("td", _hoisted_10, _toDisplayString(peopleSetUpATeam.value.length), 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleFilter('teq'))),
                    "data-test": "teqs-filter"
                  }, " Members with TEQs Completed")
                ]),
                _createElementVNode("td", _hoisted_11, _toDisplayString(peopleWithTEQs.value.length), 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (toggleFilter('plans'))),
                    "data-test": "develop-filter"
                  }, " Members with Develop Plans")
                ]),
                _createElementVNode("td", _hoisted_12, _toDisplayString(peopleWithDevelopPlans.value.length), 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (toggleFilter('pathways'))),
                    "data-test": "pathways-filter"
                  }, " Members with Pathway Progress")
                ]),
                _createElementVNode("td", _hoisted_13, _toDisplayString(peopleWithPathways.value.length), 1)
              ])
            ])
          ])
        ]),
        (appliedFilter.value)
          ? (_openBlock(), _createBlock(OrganisationDetails, {
              key: 0,
              model: _ctx.model,
              sortedMembers: sortedMembers.value,
              appliedFilter: appliedFilter.value,
              onRevalidateOrgData: revalidateOrgData
            }, null, 8, ["model", "sortedMembers", "appliedFilter"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})